export const typographyWithoutId = {
  style: [
    {
      deviceId: 'desktop',
      value: {
        fontFamily: 'Nanum Gothic Coding',
        fontSize: {
          unit: 'px',
          value: 18,
        },
        fontWeight: 400,
        lineHeight: 1.5,
      },
    },
  ],
}
